import { render, staticRenderFns } from "./OrderCancel.vue?vue&type=template&id=e523af4c&scoped=true"
import script from "./OrderCancel.vue?vue&type=script&lang=js"
export * from "./OrderCancel.vue?vue&type=script&lang=js"
import style0 from "./OrderCancel.vue?vue&type=style&index=0&id=e523af4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e523af4c",
  null
  
)

export default component.exports